import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeBodyType } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'bodyType';

export const bodyTypeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeBodyType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeBodyType }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeBodyType } = bodyTypeSlice.actions;

export const bodyType = bodyTypeSlice.reducer;
